import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "configData",
  initialState: {
    industries: [],
  },
  reducers: {
    setIndustries: (state, { payload }) => {
      state.industries = Array.isArray(payload) ? payload : [];
    },
  },
});

export const { setIndustries } = slice.actions;

export const selectIndustries = (state) => state.ConfigData?.industries ?? [];

export function getIndustryRecordId(industry) {
  if (!industry || typeof industry !== "object") return "";
  return String(industry._id ?? industry.id ?? "");
}

export default slice.reducer;
